import React, { useMemo } from 'react';
import { View, Text, StyleSheet, Linking } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { RNButton } from '@/components';

export const EntrataDisabledPaymentContent: React.FC<{ propertyId?: number }> = ({ propertyId }) => {
  const entrataUrl = useMemo(() => getEntrataUrl(propertyId), [propertyId]);

  const message = entrataUrl
    ? 'Resio is undergoing maintenance, please follow this link to pay your bills!'
    : 'Resio is undergoing maintenance. All payments and maintenance requests must be made through your community’s ResidentPortal. We apologize for this inconvenience!';

  return (
    <View style={styles.container}>
      <Text style={styles.text}>{message}</Text>
      {entrataUrl ? (
        <RNButton
          title="Make a payment"
          variant="primary"
          style={styles.button}
          onPress={() => Linking.openURL(entrataUrl)}
        />
      ) : null}
    </View>
  );
};

// Ported mapping from web's PROPERTY_ENTRATA_URLS
const PROPERTY_ENTRATA_URLS: Record<number, string> = {
  350: 'https://1047commonwealthavenue.residentportal.com/auth',
  354: 'https://academy65.residentportal.com/auth',
  347: 'https://thedeanreno.residentportal.com/auth',
  348: 'https://frisco.residentportal.com/auth',
  357: 'https://riseatnorthgateapts.residentportal.com/auth',
  346: 'https://shortbreadlofts.residentportal.com/auth',
  356: 'https://sovaks.residentportal.com/auth',
  349: 'https://academycampustown.residentportal.com/auth',
  351: 'https://academycampustown.residentportal.com/auth',
  352: 'https://academycampustown.residentportal.com/auth',
  353: 'https://academycampustown.residentportal.com/auth',
  345: 'https://academylincoln.residentportal.com/auth',
  360: 'https://thecharles.residentportal.com/auth',
  355: 'https://thedeancampustown.residentportal.com/auth',
  359: 'https://venueatnorthcampus.residentportal.com/auth',
  358: 'https://torre.residentportal.com/auth',
};

const getEntrataUrl = (propertyId?: number): string | null => {
  if (!propertyId) return null;
  return PROPERTY_ENTRATA_URLS[propertyId] || null;
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  text: {
    fontSize: 12,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
  },
  button: {
    marginTop: 12,
    alignSelf: 'flex-start',
  },
});


